export const zohoClientDetailsTableConfig = [
  {
    field: 'slNo',
    header: 'SI.No',
    className: 'zoho-client-details-first-column',
    headerClassName: 'zoho-client-details-first-column',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'zohoClientId',
    header: 'Zoho Client ID',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'clientName',
    header: 'Zoho Client Name',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'clientStatusLabel',
    header: 'Zoho Client Status',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'zoho-client-details-action-column',
    headerClassName: 'zoho-client-details-action-column',
    width: 140,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 5,
    menuItems: [],
  },
];
